<template>
  <DialogLayout
    v-model:show="dialogVisible"
    :before-close="beforeClose"
    :max-height="600"
    :max-width="800"
    :min-width="800"
    title="再次派发任务"
  >
    <div class="practice-assistant-form-re-dialog__body">
      <PracticeAssistantFormRe
        :params="params"
        :save-loading="saveLoading"
        @cancel="emit('cancel')"
        @loaded="emit('loaded', $event)"
        @success="handleSuccess"
        @update:form="emit('update:form', $event)"
      />
    </div>
  </DialogLayout>
</template>

<script setup>
import { computed } from 'vue'
import DialogLayout from '@/components/layout/dialog-layout/index.vue'
import PracticeAssistantFormRe from './index.vue'

defineOptions({
  name: 'PracticeAssistantFormReDialog'
})

const props = defineProps({
  show: {
    type: Boolean,
    default: false
  },
  params: {
    type: Object,
    default: () => ({})
  },
  saveLoading: {
    type: Boolean,
    default: false
  },
  beforeClose: {
    type: Function,
    default: (done) => done()
  }
})

const emit = defineEmits(['update:show', 'update:form', 'save', 'cancel', 'loaded', 'success'])

const dialogVisible = computed({
  get: () => props.show,
  set: (value) => {
    emit('update:show', value)
  }
})

const handleSuccess = (payload) => {
  emit('success', payload)
  emit('save', payload)
}
</script>

<style lang="scss" scoped>
.practice-assistant-form-re-dialog {
  &__body {
    min-height: 200px;
  }
}
</style>
